import React, { Component } from "react";
import PayrollPaymentForm from "../PayrollPaymentForm/PayrollPaymentForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PayrollPage
Description : Componente que contienen el formulario de la pantalla Payroll
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente PayrollForm
================================================================================ */
class PayrollPaymentPage extends Component{
    render(){
        return(
            <div>                    
                <PayrollPaymentForm/>
            </div>
        )   
    }
}

export default PayrollPaymentPage;